import axios from 'axios';

/////// job offer ////////
export const getJobOffer = (currentPage, rowsPerPage, id) =>
  axios.get(
    `job-offer/get?limit=${rowsPerPage}${rowsPerPage >= 25 ? '' : `&page=${currentPage}`}${
      id ? `&id=${id}` : ''
    }`,
  );

export const deleteJobOffer = (id) =>
  axios.put(`job-offer/delete`, {
    id,
  });

export const bulkDeleteJobOffer = (jobOffers) =>
  axios.put(`job-offer/bulk-delete`, {
    jobOffers,
  });

export const addJobOffer = (title, description) =>
  axios.post(`job-offer/create`, {
    title,
    description,
  });

export const updateJobOffer = (id, title, description) =>
  axios.put(`job-offer/update`, {
    id,
    title,
    description,
  });

/////// job application ////////

export const getJobApplication = (currentPage, rowsPerPage) =>
  axios.get(
    `job-application?limit=${rowsPerPage}${rowsPerPage >= 25 ? '' : `&page=${currentPage}`}`,
  );

export const confirmJobApplication = (applicationId) =>
  axios.put(`job-application/confirm`, {
    application_id: applicationId,
  });

export const rejectJobApplication = (applicationId) =>
  axios.put(`job-application/reject`, {
    application_id: applicationId,
  });

export const seenJobApplication = (applicationId) =>
  axios.put(`job-application/seen`, {
    application_id: applicationId,
  });
